import { COLUMN_WIDTHS } from "./ApplicationConstants";

export const WORK_TICKET_HISTORY_COL = [
  {
    key: "Ticket ID",
    value: "ticketId",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: true,
    ellipsis: false,
    width: "100px",
  },
  {
    key: "Case",
    value: "caseNumber",
    checkSouce: true,
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: false,
    width: "90px",
  },
  {
    key: "Type",
    value: "workticketType",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: false,
    width: "90px",
  },
  {
    key: "Created On",
    value: "createdOn",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: false,
    isDate: true,
    dateFormat: "MMM D, yyyy",
    width: "100px",
  },
  {
    key: "Status",
    value: "status",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: false,
    containsImage: true,
    width: "130px",
  },
  {
    key: "Status Updated",
    value: "modifiedAt",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: false,
    isDate: true,
    dateFormat: "MMM D, yyyy",
    width: "85px",
  },
  {
    key: "Work Order Owner",
    value: "workOrderOwner",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: true,
    width: "115px",
  },
  // {
  //   key: "Install Type",
  //   value: "installType",
  //   isFilterEnabled: false,
  //   filterType: "String",
  //   isCustomFilter: false,
  //   isSortable: true,
  //   isHyperLink: false,
  //   ellipsis: false,
  //   width: "68px",
  // },
  {
    key: "Has Return",
    value: "hasEsnToBeReturned",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: false,
    width: "72px",
  },
  {
    key: "Address",
    value: "addressToShow",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: true,
    width: "200px",
  },
  {
    key: "Contact",
    value: "contactName",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: true,
    width: "150px",
  },
  {
    key: "Sales Order",
    value: "salesOrderId",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: true,
    width: "80px",
  },
  {
    key: "ESN QTY",
    value: "totalEsnCount",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    ellipsis: true,
    width: "50px",
  },
  {
    key: "Originating Work Ticket",
    value: "sourceWorkticket",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: true,
    ellipsis: true,
    width: "105px",
  },
];
